import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  /* Styles applied to the root element. */
  root: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    transition: theme.transitions.create('box-shadow'),
  },
  /* Styles applied to the root element if `square={false}`. */
  rounded: {
    borderRadius: theme.shape.borderRadius,
  },
  /* Styles applied to the root element if `variant="outlined"`. */
  outlined: {
    border: `1px solid ${theme.palette.divider}`,
  },
})
export default styleOverride
